import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "./SmoothScroll";
import { mailto } from "./content";
import { EASE } from "./Reveal";
import { PromoBanner } from "./PromoBanner";

const LINKS = [["#process", "Process"], ["#sample", "Sample"], ["#pricing", "Pricing"], ["/bullet-checker", "Free checker"], ["/blog", "Tips"]];

export const Nav = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = (e, href) => {
    e.preventDefault();
    if (href.startsWith("/")) navigate(href);
    else if (pathname === "/") scrollToId(href);
    else navigate(`/${href === "#top" ? "" : href}`);
  };
  return (
  <motion.header
    initial={{ y: -30, opacity: 0 }}
    animate={{ y: 0, opacity: 1 }}
    transition={{ duration: 1, ease: EASE, delay: 0.2 }}
    className="fixed inset-x-0 top-0 z-50 border-b border-white/5 bg-[var(--ink)]/70 backdrop-blur-xl"
  >
    <PromoBanner />
    <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 sm:px-8">
      <a href="/" onClick={(e) => go(e, "#top")} data-testid="nav-home-link"><Logo /></a>
      <nav className="hidden items-center gap-9 md:flex">
        {LINKS.map(([href, label]) => (
          <a key={href} href={href.startsWith("/") ? href : `/${href}`} onClick={(e) => go(e, href)}
            data-testid={`nav-${label.toLowerCase()}-link`}
            className="group relative text-sm text-slate-300 transition-colors duration-300 hover:text-white">
            {label}
            <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[var(--teal)] transition-transform duration-500 group-hover:scale-x-100" />
          </a>
        ))}
      </nav>
      <a href={mailto("Resume bullet rewrite")} data-testid="nav-email-button"
        className="group flex items-center gap-1.5 rounded-full bg-[var(--teal)] px-4 py-2 text-sm font-semibold text-[var(--ink)] transition-transform duration-300 hover:scale-[1.04] active:scale-95">
        Email us <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
      </a>
    </div>
  </motion.header>
  );
};
